// Consultation/ConsultationConfigCard.tsx

import React from 'react';
import {Typography} from '@mui/material';
import {IConsultationConfig} from "../../Types/psychology/consultation";
import {useTheme} from "Theme/ThemeContext";
import {FC} from "WideLayout/Layouts";
import {getConsultationTypeLabel} from "Locale/ruMap";

interface ConsultationConfigCardProps {
    config: IConsultationConfig;
    selected: boolean;
    onClick: (id: number) => void;
}

const ConsultationConfigCard: React.FC<ConsultationConfigCardProps> = ({config, selected, onClick}) => {
    const {plt} = useTheme();
    const handleClick = () => {
        onClick(config.id);
    };

    return (
        <FC onClick={handleClick}
            bg={`${plt.colors.secondary.light}47`}
            cls={'ftrans-300-eio'}
            sx={{
                cursor: 'pointer',
                opacity: selected ? 1 : 0.6,
                transform: selected ? 'scale(1)' : 'scale(0.9)',
            }} px={2} py={1} rounded={3}>
            <FC>
                <Typography variant="h6" color={plt.text.primary70}>
                    {getConsultationTypeLabel(config.type.name)}
                </Typography>
                <Typography color={plt.text.primary60}>{config.duration.value} минут</Typography>
                <Typography color={plt.text.primary60}>{config.is_online ? 'Онлайн' : 'Оффлайн'}</Typography>
                <Typography
                    color={plt.text.primary60}>{config.is_supervision ? 'Супервизия' : 'Консультация'}</Typography>
            </FC>
        </FC>
    );
};

export default ConsultationConfigCard;
